export default __webpack_public_path__ + "static/media/TotalProposel.c9bcd646.svg";